import React, { useState } from 'react'
import { BaseView } from '@/components/base'
import { AppIcons } from '@/components/AppIcons'
import { NoteModal } from '@/components/NoteModal'
import { useTheme } from '@/hooks/useTheme'

interface ExpandableNoteProps {
  note: string
  subjectFullName?: string
}

export const ExpandableNote: React.FC<ExpandableNoteProps> = ({
  note,
  subjectFullName,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const theme = useTheme()

  const handleOpenModal = () => {
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  return (
    <>
      <BaseView
        style={{
          width: 22,
          height: 22,
          borderRadius: 11,
          cursor: 'pointer',
        }}
        center
        onClick={handleOpenModal}
      >
        <AppIcons name="expand" size={15} color={theme.colors.icon.primary} />
      </BaseView>

      <NoteModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        note={note}
        subjectFullName={subjectFullName}
      />
    </>
  )
}
